var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPDATE_B2B_MIS_REQUEST, updateB2BMisFailure, updateB2BMisSuccess } from "../../actions";
import APIB2B from "@/utils/APIB2B";
const updateB2BMis = (formData) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIB2B.formUpload(`/report/mis/upload`, formData)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* updateB2BMisWorker(action) {
    try {
        const data = yield call(updateB2BMis, action.payload);
        yield put(updateB2BMisSuccess(data));
    }
    catch (error) {
        yield put(updateB2BMisFailure(error));
    }
}
export function* watchUpdateB2BMisData() {
    yield takeLatest(UPDATE_B2B_MIS_REQUEST, updateB2BMisWorker);
}
